import {baseDeleteRequest} from "../base/baseDeleteRequest";

const deleteUserPin = async () => baseDeleteRequest(`user_pin/`);

export default deleteUserPin;
